import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import FAQ from "../components/Fqas/FAQ";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import DarkRoadMap from "../components/dark-roadmap/darkRoadMap";
import SimpleModels from "../components/simpleEngagementModels";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import { useTranslation } from "react-i18next";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import NewBenefitsSection from "../components/new-banefits-section/NewBenefitsSection";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import ChatBotWorkFlow from "../components/chatbbot-workflow/ChatBotWorkFlow";
import IntigrationIconsSection from "../components/integration-icons-section/IntigrationIconsSection";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import AreasWeServe from "../components/areas-we-serve/AreasWeServe";
import { AiChatBotPageDataTexas } from "../data/ai-chatbot-data-texas";
import TechStack from "../components/techstack/TechStack";
import ChatbotIntigratedSection from "../components/ChatBotIntigratedSection/ChatbotIntigratedSection";
import { AiChatBotPageData } from "../data/ai-chatbot-data";
import SecurityFIrstSection from "../components/SecurityFirstSection/SecurityFIrstSection";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";
import ModelAgnostic from "../components/ModelAgnostic/ModelAgnostic";
import ChatbotBanner from "../components/ChatbotBanner/ChatbotBanner";

const AIChatBotServicesTexas = () => {

    const { t } = useTranslation("footer");
    const footerCtaContent = t("footerCtaContent", { returnObjects: true });

    const { t: stackData } = useTranslation("aiDevelopmentPageContent");
    const coverTheStackData = stackData("aiDevCoverTheStackSection", {
        returnObjects: true,
    });

    return (
        <>
            <Helmet>
                <title>Advanced AI Chatbot Development Services for Businesses in Texas</title>
                <meta
                    name="description"
                    content="Bitsclan provides expert chatbot development services in Texas. Improve customer engagement, reduce costs & scale smarter. Start your AI chatbot journey now!"
                />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <link rel="canonical" href="https://bitsclan.com/ai-chatbot-development-company-texas" />
            </Helmet>

            <MegaMenu />

            <ChatbotBanner
                shortHeading="Best AI Chatbot Development Company in Texas"
                mainHeading="Trusted <span>AI Partner</span> Driving Digital Growth Across Texas"
                description="Whether you are looking for an AI app development company in Texas to design intuitive applications or looking to enhance customer interactions with an AI chatbot development company in Texas, Bitsclan has got you covered, delivering unparalleled value to businesses across multiple industries."
                bannerImage="/images/why-us-section/chatbot-banner.png"
            />
            <TrustedPartner category={"chatbot"} showGoogleIcons={true} heading="Trusted & Partnered by Businesses Worldwide to Build Smarter Chatbot Solutions" />

            <OurServices
                shortHeading={"Comprehensive Suite of AI Chatbot Development Services in Texas"}
                buttonText="Book a Consultation Now"
                servicesCardsData={AiChatBotPageDataTexas?.services}
                mainHeading="End-to-End Chatbot Solutions Designed for Enterprise Success"
                // mainHeading=" No Matter What You are Building, We Can Help with Expert <span>AI Solutions</span>"
                description="Discover innovative AI solutions with the best AI chatbot development company in Texas, offering customized AI chatbot & software development services & top-notch technologies like generative AI, computer vision, & NLP to empower businesses across industries."
            />

            <NewTestimonials
                shortHeading={AiChatBotPageDataTexas?.testimonialData?.shortHeading}
                mainHeading={AiChatBotPageDataTexas?.testimonialData?.mainHeading}
                description={AiChatBotPageDataTexas?.testimonialData?.description}
                content={AiChatBotPageDataTexas?.testimonialData?.testimonials}
            />

            <WhyChooseUs
                heading={AiChatBotPageDataTexas?.whyUsSectionData?.heading}
                greenHeading={AiChatBotPageDataTexas?.whyUsSectionData?.greenHeading}
                content={AiChatBotPageDataTexas?.whyUsSectionData?.content}
                shortHeading={AiChatBotPageDataTexas?.whyUsSectionData?.shortHeading}
                stats={AiChatBotPageDataTexas?.whyUsSectionData?.stats}
                cta={AiChatBotPageDataTexas?.whyUsSectionData?.cta}
                sectionImage={AiChatBotPageDataTexas?.whyUsSectionData?.image}
            />

            <NewCaseStudySection
                heading={AiChatBotPageDataTexas?.caseStudyContent?.heading}
                shortHeading={AiChatBotPageDataTexas?.caseStudyContent?.shortHeading}
                description={AiChatBotPageDataTexas?.caseStudyContent?.description}
                filter={"chatbot"}
            />

            <ChatbotIntigratedSection content={AiChatBotPageData?.integrationsData} />

            <SimpleModels content={AiChatBotPageData?.engagementModels} />

            <TechStack content={AiChatBotPageData?.techStackData} />

            <NewBenefitsSection />

            {/* <ChatBotWorkFlow />

            <IntigrationIconsSection content={AiChatBotPageDataTexas?.chatbotIntigration} /> */}

            <PioneeringChange
                shortHeading="Industries We Serve"
                tabData={AiChatBotPageDataTexas?.industriesSectionMain}
                greenHeading={"Solutions Built for the Unique Demands of Every Industry"}
                mainHeading={"Specialized Chatbot "}
                content={"Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights."}
                serviceTags={[
                    { title: "AI Chatbots", link: "/ai-chatbot-development-services" },
                    { title: "Virtual Assistants", link: "/ai-automation-agency" },
                    { title: "Conversational AI", link: "/generative-ai-development-services" }
                ]}
            />

            {/* <IndustriesTabs defaultTab={"Healthcare"} shortHeading="Industries We Serve" mainheading="Our Industry-Specific Chatbot Development Expertise" description="Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights." /> */}

            <SecurityFIrstSection />

            <ModelAgnostic />

            <CoverTheStack
                whereStart={"Deep learning frameworks"}
                shortHeading={"Technology Stack for Chatbot Development"}
                mainHeading={"Foundational Technologies Driving Conversational Intelligence"}
                subHeading={
                    "The right technology stack for chatbot development will depend on your intended use cases & channels. We engage with the leading providers from Microsoft Azure & AWS to Google Cloud for dependable, secure, & scalable solutions."
                }
                tabs={AiChatBotPageDataTexas?.techStack?.tabs}
                tabItems={AiChatBotPageDataTexas?.techStack?.tabItems}
            />

            <NewRoadMap roadmapContent={AiChatBotPageData?.roadmapContent} />

            <TrendsInsights
                category="ai-developmet"
                heading={AiChatBotPageDataTexas?.trendingInsights.heading}
                description={AiChatBotPageDataTexas?.trendingInsights.description}
            />

            <FAQ
                faqs={AiChatBotPageDataTexas.faqSection.questionAnswers}
                mainHeading={AiChatBotPageDataTexas.faqSection.heading}
            />

            <AreasWeServe />

            <SoftwareCompanyCta content={AiChatBotPageDataTexas?.companyCta} />
            <Footer />
        </>
    )
}

export default AIChatBotServicesTexas